

const state = {
    
    blocks:[
        {
            id:1,
            name: 'Specifications',
            color: '#fff',   
            columns:1,
            blockcomponents: {
                columns: [
                    //left Column
                    [
                        {
                            id:1,
                            name:'formdatatable',
                            attributes: {
                                placeholder:"Specifications",
                                size:"xs10",
                                invertedsize:"xs1",                                
                                icon:"search",                                
                                setter: 'specifications/SPECIFICATION_SET_SPECIFICATION',                                    
                                items:'specifications/specifications',
                                withcheck:false,
                                withsearch:true,
                                withdialog:false,
                                headers: [
                                    {
                                        text: 'Name',
                                        value: 'name',
                                        sortable:false
                                    },    
                                    
                                ]
                            }                                    
                        }
                    ],                   
                ]
            },
        },
        
    ]
    
};

export default {
  namespaced: false,
  state,
  
};